import * as React from 'react';

import { connect } from 'react-redux';

import { FilterBase, mapDispatchToProps, mapStateToProps } from './filter-base';

export class FilterChecklist extends FilterBase {
    convertEvtToString(evt: React.ChangeEvent<HTMLInputElement>) {
        let current = this.props.selectedOptions.split(',').filter(el => el !== "");

        if (evt.target.checked) {
            // If checked, add to list.
            current.push(evt.target.value);
            return current.join(',');
        } else {
            // If not checked, remove from list.
            return current.filter(el => el !== evt.target.value).join(',');
        }
    }

    submitChange(evt: React.ChangeEvent<HTMLInputElement>) {
     //   this.updateValue(evt);
        this.boundFilterUpdate(this.convertEvtToString(evt),true);
    }

    renderFormElement() {
        const selectedOptions = this.props.selectedOptions.split(',')

        return (
            <fieldset>
                <legend>{this.props.title}</legend>

                <ul className="adage-form-list adage-form-list-vertical">
                    {
                        this.props.options.map(option => {
                            return (
                                <li key={`${option.value}~${option.text}`}>
                                    <input type="checkbox" id={`${this.props.title}~${option.value}~${option.text}`} value={option.value} checked={!this.props.selectedOptions?false:selectedOptions.indexOf(option.value) !== -1} onChange={this.submitChange.bind(this)} />
                                    <label htmlFor={`${this.props.title}~${option.value}~${option.text}`}>{option.text}</label>
                                </li>
                            )
                        })
                    }
                </ul>
            </fieldset>
        )
    }
}

export const ConnectedFilterChecklist = connect(mapStateToProps, mapDispatchToProps)(FilterChecklist);